<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
      </ol>
    </nav>

    <h1 class="page-header-title" id="operationInternalEvent">
      {{
        'operationInternalEventModule.createOperationInternalEvent' | translate
      }}
    </h1>
  </header>
  <!-- End Page Header -->

  <section class="card" aria-labelledby="operationInternalEvent">
    <div class="card-body">
      <div>
        <operation-internal-event-form (onSubmit)="onSubmit($event)">
        </operation-internal-event-form>
      </div>
    </div>
  </section>
</div>
